import { ErrorHandler, Injectable } from '@angular/core';
import { TMEventJSError, TMEventType, TagManagerEventService } from '../service/tag-manager.service';

/**
 * Provide global error handler for the application.
 */
@Injectable()
export class GlobalErrorHandler extends ErrorHandler
{
    constructor(private tmService: TagManagerEventService)
    {
        super();
    }

    /**
     * Handle JavaScript error handler method.
     *
     * @param error Error event raised.
     */
    public handleError(error: ErrorEvent): void
    {
        // Send JavaScript errors to Tag Manager
        if (this.tmService.enabled)
        {
            const tmObj: TMEventJSError = { errorMessage: error.message ? error.message : error.toString() };
            this.tmService.sendTagManagerEvent(TMEventType.jsPageError, tmObj);
        }
        // Call handleError from base class
        super.handleError(error);
    }
}
